export default __webpack_public_path__ + "static/Quickinstallation_Tile_8015_Step_05-2005e3a94a853fd229ac3afb6c6a635f.webp";